<template>
  <div v-if="items.length" style="padding: 10px">
    <table>
      <tr>
        <th>Day</th>
        <th>Total Calls</th>
        <th>Incoming Calls</th>
        <th>Outgoing Calls</th>
        <th>SMS Sent</th>
        <th>Incoming Unique Phone Number</th>
      </tr>
      <tr v-for="item in items">
        <th>{{ item.day }}</th>
        <td>{{ item.data.incomingCount + item.data.outgoingCount }}</td>
        <td>{{ item.data.incomingCount }}</td>
        <td>{{ item.data.outgoingCount }}</td>
        <td>{{ item.data.smsCount }}</td>
        <td>{{ Object.keys(item.data.incomingNumbers).length }}</td>
      </tr>
    </table>
  </div>
</template>

<style scoped>
  td, th {
    border: 1px solid gray;
    padding: 8px;
  }
  #calls-table {
    grid-template-columns: auto auto auto auto auto auto auto auto auto;
  }
</style>

<script>
import api from '../services/api';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      items: [],
    }
  },
  async created() {
    document.title = 'Call Stats';
    const logs = (await api.getCallcentreLogs({hoursLimit: 100000})).logs;
    const stats = {};
    logs.forEach(log => {
      const day = dayjs(log.receivedAt).format('YYYY-MM-DD');
      if (!stats[day]) {
        stats[day] = {
          incomingNumbers: {},
          outgoingCount: 0,
          incomingCount: 0,
          smsCount: 0,
        };
      }
      if (log.agent !== 'external' && log.agent && log.type !== 'SMS') {
        stats[day].outgoingCount++;
      } else if (log.type !== 'SMS') {
        stats[day].incomingCount++;
        stats[day].incomingNumbers[log.from] = true;
      } else if (log.type === 'SMS') {
        stats[day].smsCount++;
      }
      this.items = Object.keys(stats).sort().reverse().map(key => {
        return {
          day: key,
          data: stats[key]
        };
      });
      // console.log(day);
    });
  },
  methods: {
  }
}
</script>
